<template>
	<j-card class="bg5">
		<!-- Header -->
		<div class="flex wrap xs-12 p4 bb1 bc7">
			<div class="xs-6">
				<img :src="insurerLogoUrl" height="50" v-if="insurerLogoUrl" />
			</div>
			<div class="xs-6 ta3">
				<div class="fs5 fw7 lh125">{{ policyNumber }}</div>
				<div class="fs3 c6">{{ $t("policy_number") }}</div>
			</div>

			<!-- Update button -->
			<div class="xs-12 flex xs-right">
				<j-button
					type="tertiary"
					@click="$modal.show('updateParticulars')"
					v-can="'writePolicies'"
				>
					<crm-icon name="edit" size="small" color="c2" />
					{{ $t("update") }}
				</j-button>
			</div>
		</div>

		<!-- Items -->
		<j-list :list="computedParticulars">
			<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
				<div class="flex xs-6 xs-left xs-middle fw7 c6 lh125">
					{{ item.label }}
				</div>
				<div class="flex xs-6 xs-left xs-middle lh125">
					<router-link :to="item.link" v-if="item.link">
						{{ item.value }}
					</router-link>
					<template v-else>{{ item.value }}</template>
				</div>
			</div>
		</j-list>

		<!-- Empty -->
		<div class="bg5 ta2 fs3 p2" v-if="computedParticulars.length === 0">
			{{ $t("errors.no_data") }}
		</div>

		<!-- Modal for update -->
		<core-modal name="updateParticulars" :headline="$t('update_particulars')">
			<update-particulars :data="particulars" @updated="$emit('updated')" />
		</core-modal>
	</j-card>
</template>

<script>
import JCard from "@/components/JCard"
import JList from "@/components/JList"
import CoreModal from "@/modules/core/components/CoreModal"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import UpdateParticulars from "./UpdateParticulars"
import dayjs from "dayjs"
import get from "lodash.get"
export default {
	components: { JCard, JList, CoreModal, JButton, CrmIcon, UpdateParticulars },
	props: {
		particulars: {
			type: Object,
			required: true,
			default: () => {}
		}
	},
	computed: {
		policyNumber() {
			return this.particulars.issuerNumber
				? this.particulars.issuerNumber
				: "---"
		},
		insurerLogoUrl() {
			return get(
				this,
				"particulars.acceptedOffer.product.insurer.logoUrls.typeA",
				null
			)
		},
		// What will be displayed in the list component
		computedParticulars() {
			const data = this.particulars
			return [
				{
					label: this.$t("client"),
					value: get(data, "holder.name"),
					link: `/${this.$store.state.tenantId}/clients/detail/${get(
						data,
						"holder.id"
					)}/overview/${get(data, "holder.__typename")}`
				},
				{
					label: this.$t("start_date"),
					value: data.startDate
						? dayjs(data.startDate).format(
								this.$store.state.settings.dateFormat
						  )
						: null
				},
				{
					label: this.$t("end_date"),
					value: data.endDate
						? dayjs(data.endDate).format(this.$store.state.settings.dateFormat)
						: null
				},
				{
					label: this.$t("issue_date"),
					value: data.issueDate
						? dayjs(data.issueDate).format(
								this.$store.state.settings.dateFormat
						  )
						: null
				},
				{
					label: this.$t("referrer"),
					value: get(data, "referrer.name", null)
				},
				{ label: this.$t("source"), value: data.source },
				{
					label: this.$t("channel"),
					value: get(data, "client.name", "")
						? get(data, "client.name", "").toUpperCase()
						: get(data, "client.id", "").toUpperCase()
				}
			]
		}
	}
}
</script>
